<ng-template #summary let-allowAutoLayoutChange="allowAutoLayoutChange" let-trackWithDialog="trackWithDialog">
  <orderform-buy-summary
    [layout]="summaryLayout"
    [allowAutoLayoutChange]="allowAutoLayoutChange"
    [innerContainerClasses]="summaryInnerContainerClasses"
    [outerContainerClasses]="summaryOuterContainerClasses"
    [title]="(isGift$ | async) === true ? modalTitleAsGift : modalTitle"
  >
    <div
      *ngIf="paymentLegalHint$ | async as paymentLegalHint"
      class="buy-button-legal-notice"
      [ngClass]="{ 'legal-text': (resellerId$ | async) === SiteOwners.DIGISTORE24_INC }"
      [innerHTML]="paymentLegalHint"
    ></div>
    <div
      *ngIf="(isGift$ | async) === true"
      class="buy-button-legal-notice buy-button-order-gift-notice"
      i18n="@@buy_button.buy-verification.buy-button-order-gift-notice"
      >Die Bestellung ist ein Geschenk. Sie können nach der Zahlung eine Grußnachricht und das Datum für den Erhalt des
      Geschenks festlegen.
    </div>
    <orderform-buy-button
      *ngIf="isButtonVisible$ | async"
      [theme]="buyBtnTheme"
      [iconLeft]="iconLeft"
      [iconRight]="iconRight"
      [sealType]="sealType"
      [customText]="buyBtnText"
      [text]="buttonText$ | async"
      [disabled]="!!(buttonDisabled$ | async)"
      (submit)="submit(trackWithDialog)"
    ></orderform-buy-button>
  </orderform-buy-summary>
</ng-template>

<p-dialog
  [(visible)]="modalVisible"
  [dismissableMask]="false"
  [draggable]="false"
  [modal]="true"
  [breakpoints]="{ '992px': '75vw', '640px': '90vw' }"
  [attr.data-e2e]="'form:buy-verification:modal'"
  [showHeader]="false"
  [contentStyleClass]="'clear_modal'"
  [closeOnEscape]="true"
  [closable]="true"
  transitionOptions="0ms"
>
  <ng-template pTemplate="content">
    <a href="javascript:void(0)" (click)="modalVisible = false" class="modal-close">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.5 1.56818L14.4242 0.5L8 6.93182L1.56818 0.5L0.5 1.56818L6.93182 8L0.5 14.4242L1.56818 15.5L8 9.06818L14.4242 15.5L15.5 14.4242L9.06818 8L15.5 1.56818V1.56818Z"
          fill="white"
        />
      </svg>
    </a>
    <ng-container
      *ngTemplateOutlet="summary; context: { allowAutoLayoutChange: true, trackWithDialog: true }"
    ></ng-container>
  </ng-template>
</p-dialog>

<ng-container *ngIf="(showSummary$ | async) === true; else showOnlyButton">
  <ng-container *ngTemplateOutlet="summary; context: { allowAutoLayoutChange: false }"></ng-container>
</ng-container>

<ng-template #showOnlyButton>
  <ng-container *ngIf="(needToShowOrderSummaryBeforePurchase$ | async) === true; else showButtonForOrderWithoutSummary">
    <orderform-buy-button
      *ngIf="isButtonVisible$ | async"
      [theme]="buyBtnTheme"
      [iconLeft]="iconLeft"
      [iconRight]="iconRight"
      [sealType]="sealType"
      [customText]="buyBtnText"
      [text]="buttonTextBeforeOrderSummary$ | async"
      [disabled]="!!(buttonDisabled$ | async)"
      (submit)="showSummaryDisalog()"
    ></orderform-buy-button>
  </ng-container>

  <ng-template #showButtonForOrderWithoutSummary>
    <div
      *ngIf="paymentLegalHint$ | async as paymentLegalHint"
      class="buy-button-legal-notice"
      [ngClass]="{ 'legal-text': (resellerId$ | async) === SiteOwners.DIGISTORE24_INC }"
      [innerHTML]="paymentLegalHint"
    ></div>
    <div
      *ngIf="(isGift$ | async) === true"
      class="buy-button-legal-notice buy-button-order-gift-notice"
      i18n="@@buy_button.buy-verification.buy-button-order-gift-notice"
      >Die Bestellung ist ein Geschenk. Sie können nach der Zahlung eine Grußnachricht und das Datum für den Erhalt des
      Geschenks festlegen.
    </div>
    <orderform-buy-button
      *ngIf="isButtonVisible$ | async"
      [theme]="buyBtnTheme"
      [iconLeft]="iconLeft"
      [iconRight]="iconRight"
      [sealType]="sealType"
      [customText]="buyBtnText"
      [text]="buttonText$ | async"
      [disabled]="!!(buttonDisabled$ | async)"
      (submit)="submit()"
    ></orderform-buy-button>
  </ng-template>
</ng-template>
